import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY. Copia .env.example a .env.local y completa los valores.',
  );
}

/** Cliente unico de Supabase para toda la app. Es el MISMO proyecto que usa Treid OP. */
export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    // ⚠️ Distinto al de Treid OP (`treid-campo-auth`) a proposito: si algun dia las dos
    // apps comparten dominio, una pisaria la sesion de la otra y la persona se veria
    // deslogueada de una al entrar a la otra, sin explicacion.
    storageKey: 'academia-treid-auth',
  },
  global: { headers: { 'x-client-info': 'academia-treid-web' } },
});
